// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { socket, diagnostics } from './socket';
import clientLogger from './services/clientLogger';

// CSS imports - порядок важен для каскада
import './styles/variables.css';       // CSS переменные
import './styles/base.css';           // Базовые стили
import './styles/layout.css';         // Стили для основных макетов
import './styles/components.css';     // Стили для компонентов
import './styles/chat.css';           // Стили для чата
import './styles/queue.css';          // Стили для очереди
import './styles/animations.css';     // Анимации
import './styles/responsive.css';     // Адаптивные стили (должны идти последними)

// Service Worker registration for production caching
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('Service Worker registered successfully:', registration.scope);
      
      // Update notification
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available
              console.log('New app version available! Please refresh the page.');
            }
          });
        }
      });
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  });
}

// Глобальные команды для отладки Vibio
window.vibio = {
    // Тест Socket.IO подключения
    testSocket: () => diagnostics.testConnection(),
    
    // Информация о сети
    networkInfo: () => diagnostics.getNetworkInfo(),
    
    // Принудительное переподключение Socket.IO
    reconnect: () => {
        console.log('🔄 Forcing Socket.IO reconnection...');
        socket.disconnect();
        setTimeout(() => socket.connect(), 1000);
    },
    
    // Показать справку
    help: () => {
        console.log(`
🎬 === VIBIO DEBUG COMMANDS ===

📋 Доступные команды:
  vibio.testSocket()        - Тест Socket.IO подключения  
  vibio.networkInfo()       - Информация о сети
  vibio.reconnect()        - Переподключить Socket.IO
  vibio.help()             - Показать эту справку

🔧 Быстрые решения проблем:
  • Мобильный не подключается? Используй IP вместо localhost
  • Backend недоступен? Проверь node server.js в папке backend  
  • Socket.IO ошибки? Проверь настройки сервера

💡 Примеры использования:
  vibio.networkInfo()
        `);
    }
};

// Показать приветственное сообщение в консоли
console.log(`
🎬 === VIBIO Video Room App ===
✅ Debug commands available! Type: vibio.help()
🔍 Quick network test: vibio.diagnose()
🌐 Current URL: ${window.location.href}
`);

// Відправляємо базову інформацію в бекенд для мобільної діагностики
try {
  clientLogger.info('App start', {
    href: window.location.href,
    ua: navigator.userAgent,
    online: navigator.onLine,
    language: navigator.language,
  }, 'BOOT');
} catch {}

// Глобальні перехоплювачі помилок для мобільної версії
window.addEventListener('error', (e) => {
  try { clientLogger.error('window.error', { message: e.message, filename: e.filename, lineno: e.lineno, colno: e.colno }, 'JS'); } catch {}
});
window.addEventListener('unhandledrejection', (e) => {
  try { clientLogger.error('unhandledrejection', { reason: String(e.reason) }, 'JS'); } catch {}
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
